// extracted by mini-css-extract-plugin
module.exports = {"headerControlsSave":"HasChanges_headerControlsSave__1_d5P","timeText":"HasChanges_timeText__35Lz4","timeTextButton":"HasChanges_timeTextButton__1zdA-"};